import { useLayoutEffect, useState } from 'react';

import { debounce } from 'LEGACY/eventDelaying';

export default function useSize(ref) {
  /**
   * Custom hook to manage window resizing events.
   */
  const [size, setSize] = useState(0);
  let containerResizeObserver;

  const updateSize = () => {
    setSize(ref.current.clientWidth);
  };

  useLayoutEffect(() => {
    if (!ref?.current || containerResizeObserver) {
      return;
    }
    if (('ResizeObserver' in window)) {
      containerResizeObserver = new window.ResizeObserver(debounce(updateSize, 200));
      containerResizeObserver.observe(ref.current);
    } else {
      window.addEventListener('resize', debounce(updateSize, 200));
    }
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
      return containerResizeObserver?.unobserve(ref.current);
    };
  }, [ref.current]);
  return size;
}
